import {
    GenericSuspense,
    IconButton,
    RightSidebar,
    useBreakpoints,
    useUrlParamsValue
} from "@mzara/component";
import { VacationContainer } from "@mzara/project";
import { calendarOpenState } from "components/layout/AdminNavBar";
import { useState } from "react";
import { Outlet } from "react-router-dom";
import BarLoader from 'react-spinners/BarLoader';
import { useRecoilState } from "recoil";
import { AdminLeftSideBar } from "./AdminLeftSideBar";
import { AdminNavBar as NavBar } from "./AdminNavBar";
import { NotificationDialog } from "@mzara/notification";

const AdminLayout = () => {
    const { sm } = useBreakpoints()
    const [openSidebar, setOpenSidebar] = useState(!sm);
    const [openCalendar] = useRecoilState(calendarOpenState);

    const toogleSidebar = () => {
        setOpenSidebar(!openSidebar);
    };

    const urlParams = useUrlParamsValue();
    const hideSidebar = urlParams.create || urlParams.eventId;

    return (
        <>
            <div className="admin-layout flex w-full">
                <div
                    onClick={() => setOpenSidebar(false)}
                    className={`sidebar-left-mask ${openSidebar ? "open" : ""}`}
                >
                    <IconButton
                        icon={"fa-solid fa-xmark"}
                        className={"absolute top-2 right-4 text-lg text-white sm:hidden"}
                        onClick={() => setOpenSidebar(false)}
                    />
                </div>
                <AdminLeftSideBar open={openSidebar} />

                <main className="w-full transition-all duration-1000 ease-in-out flex-1 flex flex-col !bg-body-background">
                    <NavBar onToggleClick={() => toogleSidebar()} />
                    <GenericSuspense
                        fallback={
                            <BarLoader className='main-spinner-bar-loader shadow-sm' width="100%" />
                        }
                    >
                        <div className="flex items-start w-full p-0 parent-layout">
                            <Outlet />
                        </div>
                    </GenericSuspense>
                </main>
            </div>

            <NotificationDialog />
        </>
    );
};

export default AdminLayout;
